<!-- 
Doughnut chart.

Unlike most of our components you must call the "display" method to trigger displaying the chart.
Call display inside a $nextTick - see LevyComponentsWidget for an example.
-->
<script>
import _ from "underscore";
import { Doughnut } from "vue-chartjs";
import { DefaultColors } from "@/components/common/chart/helper.js";
import { deepCopy } from "@/store/helpers";

export default {
  extends: Doughnut,
  props: {
    chartData: {
      type: Object,
      default: null
    },
    chartOptions: {
      type: Object,
      default: null
    }
  },
  methods: {
    display() {
      const data = deepCopy(this.chartData);
      if (data && data.datasets) {
        _.each(data.datasets, d => {
          d.backgroundColor = d.backgroundColor || DefaultColors;
          d.borderWidth = 2;
        });
      }
      var options = this.chartOptions || {
        responsive: true,
        maintainAspectRatio: false
      };
      options.tooltips = options.tooltips || {};
      options.cutoutPercentage = options.cutoutPercentage || 30;
      options.tooltips.mode = "point";
      this.renderChart(data, options);
    }
  }
};
</script>
